import { ReactNode } from "react";
import { Icon } from "@/shared/ui";

type Props = {
  icon: ReactNode;
  title: string;
  value: string;
};

export default function AccountStatsItem({ icon, title, value }: Props) {
  return (
    <div className="px-5 relative z-1 h-26.5 py-4 gap-3.5 items-center rounded-xl border border-dark-800 whitespace-nowrap leading-none">
      {icon}
      <div>{title}:</div>
      <div className="font-bold text-accent mt-1.5">{value}</div>
    </div>
  );
}
